import {BijbError} from '../../models/bijb-error';
import {DressCode} from '../../models/dress-code';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class DressCodeState extends LoadableState {
  public static readonly key = 'DressCodeState';

  @autoserializeAs(DressCode, 'dressCode')
  public dressCode: DressCode = null;

  @autoserializeAs(BijbError, 'error')
  public error: BijbError = null;
}
